var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-data-table", {
        staticStyle: { "white-space": "nowrap" },
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "hide-default-header": _vm.empty,
          height: _vm.items.length > 7 ? 32 * 7 + 32 + 16 : undefined,
          "disable-pagination": "",
          "hide-default-footer": "",
          dense: "",
          "show-select": _vm.bulkMode,
          "item-key": "item.string",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "top",
              fn: function () {
                return [
                  _c(
                    "v-toolbar",
                    { attrs: { flat: "", dense: "" } },
                    [
                      _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                      _c("v-divider", {
                        staticClass: "mx-2",
                        attrs: { inset: "", vertical: "" },
                      }),
                      !_vm.readonly
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              attrs: { small: "", color: "primary" },
                              on: { click: _vm.row_create },
                            },
                            [_vm._v("Add")]
                          )
                        : _vm._e(),
                      _c("v-spacer"),
                      _c("v-switch", {
                        attrs: {
                          label: "AND/OR",
                          color: "success",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.anyof,
                          callback: function ($$v) {
                            _vm.anyof = $$v
                          },
                          expression: "anyof",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.showBulk && !_vm.readonly && _vm.items.length >= 2
                    ? _c(
                        "div",
                        { staticClass: "d-flex pl-4 pb-1 align-center" },
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-0 pt-0",
                            attrs: {
                              "hide-details": "",
                              disabled: !_vm.items.length,
                            },
                            model: {
                              value: _vm.bulkMode,
                              callback: function ($$v) {
                                _vm.bulkMode = $$v
                              },
                              expression: "bulkMode",
                            },
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2 white--text",
                              attrs: {
                                "x-small": "",
                                color: "red",
                                disabled:
                                  !_vm.bulkMode || !_vm.deletableCountLocal,
                              },
                              on: { click: _vm.bulkRemove },
                            },
                            [
                              _vm._v(" Bulk Delete "),
                              _vm.deletableCountLocal
                                ? _c("span", [
                                    _vm._v(
                                      " (" +
                                        _vm._s(_vm.deletableCountLocal) +
                                        ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "item.amount",
              fn: function ({ item }) {
                return [
                  _c("div", [
                    _vm._v(_vm._s(item.amount > 0 ? item.amount : "-")),
                  ]),
                ]
              },
            },
            {
              key: "item.strict",
              fn: function ({ item }) {
                return [_c("div", [_vm._v(_vm._s(item.strict ? "ON" : "OFF"))])]
              },
            },
            !_vm.readonly
              ? {
                  key: "item.actions",
                  fn: function ({ item }) {
                    return [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.row_update(item)
                            },
                          },
                        },
                        [_vm._v("mdi-pencil")]
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.row_copy(item)
                            },
                          },
                        },
                        [_vm._v("mdi-content-copy")]
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.row_remove(item)
                            },
                          },
                        },
                        [_vm._v("mdi-delete")]
                      ),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c("r-guard-rule-dialog", { ref: "dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }